// src/data/questions/index.ts
// Central export for all questions

import { Question } from '../../types';
import { profileQuestions } from './profileQuestions';
import { privacyQuestions } from './privacyQuestions';
import { adminQuestions } from './adminQuestions';
import { physicalQuestions } from './physicalQuestions';
import { technicalQuestions } from './technicalQuestions';
import { breachQuestions } from './breachQuestions';
import { baQuestions } from './baQuestions';
import { aiQuestions } from './aiQuestions';

export const questions: Question[] = [
  ...profileQuestions,      // Q1-Q4
  ...privacyQuestions,       // Q5-Q10
  ...adminQuestions,         // Q11-Q20
  ...physicalQuestions,      // Q21-Q25
  ...technicalQuestions,     // Q26-Q32
  ...breachQuestions,        // Q33-Q36
  ...baQuestions,            // Q37-Q40
  ...aiQuestions,            // Q41-Q50
];
